import { EmployeeHeader } from "./components/EmployeeHeader";
import { EmployeeTable } from "./components/EmployeeTable";
import { JSX } from "react";

export const EmployeePageContainer = (): JSX.Element => {
    return (
        <section className="p-employee">
            <EmployeeHeader />
            <EmployeeTable />
        </section>
    );
};
